module.exports = __webpack_public_path__ + "assets/media/google-color.461ebecb.svg";